import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertComponent } from '../common/alert/alert.component';
import { GlobalService } from '../services/global.service';
import { CreateFormulaModelComponent } from './create-formula-model/create-formula-model.component';


@Component({
  selector: 'app-kpiformulabuilder',
  templateUrl: './kpiformulabuilder.component.html',
  styleUrls: ['./kpiformulabuilder.component.css']
})
export class KpiFormulaBuilderComponent {
  fbDialogRef = null;
  constructor(public dialog: MatDialog,
    public globals: GlobalService,
    private readonly titleService: Title,
    private readonly router: Router
  ) {
    titleService.setTitle('Formula Builder');
  }

  /**
   * open create model on click of + button
   */
  openFBDialog() {
    if (this.fbDialogRef == null) {
      const data: any = {};
      data.FormulaList = null;
      data.UsedFor = 'create';
      this.fbDialogRef = this.dialog.open(CreateFormulaModelComponent, {
        data: data, panelClass: 'custom-modalbox'
      });
      this.fbDialogRef.afterClosed().subscribe(result => {
        this.fbDialogRef = null;
        if (result === 'Success') {
          this.globals.showAlert(AlertComponent, { success: true, message: 'Formula Created Successfully' });
          this.router.navigate(['FormulaBuilder/viewFormula']);
        } else if (result !== 'Cancel') {
          this.globals.showAlert(AlertComponent, { success: false, message: result.m_StringValue });
        }
      });
    }
  }

}
